var DateUtils ={
    displayDate: function (data, format) {
        let dateDate = new Date(data);
        let month = dateDate.getMonth() + 1;
        if (month < 10) {
            month = "0" + month;
        }
        let year = dateDate.getFullYear();
        let date = dateDate.getDate();
        if (date < 10) {
            date = "0" + date;
        }
        let second = dateDate.getSeconds();
        let minute = dateDate.getMinutes();
        let hour = dateDate.getHours();
        let dateStr = format.replace("dd", date).replace("MM", month).replace("yyyy", year).replace("mm", minute).replace("hh", hour).replace("ss", second);
        return dateStr;
    },
    
    checkIsDate: function (value) {
        if(value instanceof Date){
            return true;
        }
        try {
            let date = value.split("T")[0];
            let time = value.split("T")[1];
            let year = parseInt(date.split("-")[0]);
            let month = parseInt(date.split("-")[1]);
            let day = parseInt(date.split("-")[2]);
            let hour = parseInt(time.split(":")[0]);
            let minute = parseInt(time.split(":")[1]);
            let second = parseInt(time.split(":")[2]);
            if (year >0 && month >= 0 && month < 12 && day >= 1 && day <= 31) {
                return true;
            }
            return false;
        } catch (e){
            return false;
        }
    }
};

export default DateUtils;